module.exports = __webpack_public_path__ + "img/5.c68c647b.jpg";